import { render } from "./Dialog.vue?vue&type=template&id=edfa87ac&ts=true"
import script from "./Dialog.ts?vue&type=script&lang=ts&external"
export * from "./Dialog.ts?vue&type=script&lang=ts&external"

import "./Dialog.vue?vue&type=style&index=0&id=edfa87ac&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__